import { useBackend } from "../../services";

export const useGetLabelProducts = () => {
  const { get } = useBackend();
  const getLabelProducts = () => get("products/labels");
  return { getLabelProducts };
};
